const TabbyIcon = () => {
  return (
    <svg
      width="47"
      height="18"
      viewBox="0 0 47 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.36 18H3.63998C1.63188 18 0 16.431 0 14.4959V3.49962C0 1.56895 1.63188 0 3.63998 0H43.36C45.3728 0 47 1.56895 47 3.49962V14.4959C47 16.431 45.3681 18 43.36 18Z"
        fill="url(#paint0_linear_28768_25643)"
      />
      <path
        d="M40.6745 5.71057L38.1632 14.9389L38.1538 14.957H40.1149L42.6356 5.71057H40.6745Z"
        fill="#292929"
      />
      <path
        d="M9.57025 10.9601C9.3116 11.0912 8.95889 11.168 8.62499 11.168C7.91956 11.168 7.51982 11.0595 7.4775 10.5124V10.4763C7.4775 10.4537 7.4728 10.431 7.4728 10.4084V8.81688L7.4775 8.62697V7.50113H7.4728V7.02185L7.4775 6.83195V5.74679L5.72805 5.96835C6.91316 5.74679 7.59037 4.84702 7.59037 3.95177V3.40015H5.62459V5.98191L5.51172 6.01356V10.7973C5.57756 12.1402 6.49931 12.9405 8.00892 12.9405C8.54504 12.9405 9.13289 12.8229 9.58436 12.6285L9.59377 12.624V10.9465L9.57025 10.9601Z"
        fill="#292929"
      />
      <path
        d="M9.88067 5.36243L4.36426 6.18081V7.52369L9.88067 6.70531V5.36243Z"
        fill="#292929"
      />
      <path
        d="M9.88067 7.32935L4.36426 8.14773V9.43183L9.88067 8.61344V7.32935Z"
        fill="#292929"
      />
      <path
        d="M16.065 7.94873C15.9851 6.45664 15.0163 5.57043 13.4362 5.57043C12.5285 5.57043 11.7761 5.90955 11.2682 6.54707C10.7602 7.1846 10.4922 8.12055 10.4922 9.25544C10.4922 10.3903 10.7602 11.3308 11.2682 11.9638C11.7761 12.6013 12.5285 12.9404 13.4362 12.9404C15.0163 12.9404 15.9898 12.0497 16.065 10.5486V12.8003H18.0308V5.72416L16.065 6.01354M16.1685 9.25544C16.1685 10.5802 15.4443 11.4348 14.3297 11.4348C13.1775 11.4348 12.4909 10.6209 12.4909 9.25544C12.4909 7.88543 13.1775 7.06252 14.3297 7.06252C14.8893 7.06252 15.3596 7.27051 15.6841 7.6684C15.9992 8.06177 16.1685 8.60887 16.1685 9.25544Z"
        fill="#292929"
      />
      <path
        d="M23.7636 5.57041C22.1788 5.57041 21.21 6.45662 21.1347 7.95323V3.66687L19.1689 3.95624V12.8003H21.1347V10.5486C21.21 12.0497 22.1835 12.9404 23.7636 12.9404C25.6165 12.9404 26.7217 11.5614 26.7217 9.25542C26.7217 6.94946 25.6165 5.57041 23.7636 5.57041ZM22.8701 11.4348C21.7508 11.4348 21.0313 10.5802 21.0313 9.25542C21.0313 8.60884 21.2006 8.06175 21.5157 7.6729C21.8401 7.27501 22.3104 7.06702 22.8701 7.06702C24.0223 7.06702 24.7089 7.88541 24.7089 9.25994C24.7089 10.6209 24.0223 11.4348 22.8701 11.4348Z"
        fill="#292929"
      />
      <path
        d="M32.0688 5.57041C30.4839 5.57041 29.5151 6.45662 29.4399 7.95323V3.66687L27.4741 3.95624V12.8003H29.4399V10.5486C29.5151 12.0497 30.4886 12.9404 32.0688 12.9404C33.9217 12.9404 35.0269 11.5614 35.0269 9.25542C35.0269 6.94946 33.9217 5.57041 32.0688 5.57041ZM31.1799 11.4348C30.0607 11.4348 29.3411 10.5802 29.3411 9.25542C29.3411 8.60884 29.5104 8.06175 29.8255 7.6729C30.15 7.27501 30.6203 7.06702 31.1799 7.06702C32.3321 7.06702 33.0187 7.88541 33.0187 9.25994C33.0187 10.6209 32.3321 11.4348 31.1799 11.4348Z"
        fill="#292929"
      />
      <path
        d="M35.0312 5.71057H37.1287L38.8358 12.7912H36.9547L35.0312 5.71057Z"
        fill="#292929"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28768_25643"
          x1="0"
          y1="8.99929"
          x2="47.0005"
          y2="8.99929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3BFF9D" />
          <stop offset="1" stop-color="#3BFFC8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TabbyIcon;
